import PropTypes from 'prop-types';
import React from 'react';

import Button, { TYPES } from 'components/Button';
import { SubBold } from 'components/Sub';
import Theme from 'styles/theme';
import I18n from 'utils/I18n';

import { CLOSE_MODAL_TYPES, CLOSE_MODAL_LOCATIONS } from './constants';

const Subtotal = ({ subtotal, smallButtons, closeModal, openCart }) => {
  const handleViewCartClick = () => {
    closeModal({
      closeType: CLOSE_MODAL_TYPES.BUTTON,
      closeLocation: CLOSE_MODAL_LOCATIONS.VIEW_CART_AND_CHECKOUT,
    });
    openCart();
  };

  return (
    <div className="Subtotal">
      <div className="Subtotal__top">
        <SubBold>
          {I18n.localize('cart.subtotal')}
          <div className="Subtotal__price">{subtotal}</div>
        </SubBold>
      </div>
      <div className="Subtotal__buttons">
        <Button
          type={TYPES.DEFAULT}
          className="Subtotal__view-cart"
          onClick={handleViewCartClick}
          isFullWidth
          isSmall={smallButtons}
        >
          {I18n.localize('cart.viewCartCheckout')}
        </Button>
      </div>
      <Button
        type={TYPES.OUTLINE}
        className="Subtotal__continue-shopping"
        onClick={() =>
          closeModal({
            closeType: CLOSE_MODAL_TYPES.BUTTON,
            closeLocation: CLOSE_MODAL_LOCATIONS.CONTINUE_SHOPPING,
          })
        }
        isFullWidth
        isSmall={smallButtons}
      >
        {I18n.localize('cart.continueShopping')}
      </Button>
      <style jsx global>
        {`
          .Subtotal__top {
            display: inline-block;
            padding-bottom: ${Theme.get('spacing') * 3}px;
            width: 100%;
          }

          .Subtotal__price {
            float: right;
          }

          .Subtotal__view-cart {
            margin-bottom: ${Theme.get('spacing')}px;
          }
        `}
      </style>
    </div>
  );
};

Subtotal.propTypes = {
  subtotal: PropTypes.string.isRequired,
  smallButtons: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
  openCart: PropTypes.func.isRequired,
};

export default Subtotal;
